import { render } from "./IdModal.vue?vue&type=template&id=35c66f07"
import script from "./IdModal.vue?vue&type=script&lang=js"
export * from "./IdModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__